import { connect } from 'react-redux';
import { selectUsername } from '../../../../redux/selectors/auth';
import { StateType } from '../../../../types';

const mapStateToProps = (state: StateType) => ({
  userName: selectUsername(state),
});

export default connect(mapStateToProps);
